(() => {
  // src/carousel.ts
  (() => {
    const blockClickWhenDisabled = (btn) => {
      if (!btn) return;
      btn.addEventListener(
        "click",
        (e) => {
          if (btn.classList.contains("swiper-button-disabled")) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
        },
        true
      );
    };
    class CarouselElement extends HTMLElement {
      constructor() {
        super(...arguments);
        this._swiper = null;
      }
      connectedCallback() {
        if (this._swiper) return;
        const parsed = Number(this.dataset.slidesPerView);
        const fixedPerView = Number.isFinite(parsed) && parsed > 0 ? parsed : null;
        const parsedMd = Number(this.dataset.slidesPerViewMd);
        const fixedPerViewMd = Number.isFinite(parsedMd) && parsedMd > 0 ? parsedMd : null;
        const parsedLg = Number(this.dataset.slidesPerViewLg);
        const fixedPerViewLg = Number.isFinite(parsedLg) && parsedLg > 0 ? parsedLg : null;
        let breakpoints;
        if (fixedPerViewMd) {
          breakpoints = { 400: { slidesPerView: fixedPerViewMd } };
          if (fixedPerViewLg) breakpoints[600] = { slidesPerView: fixedPerViewLg };
        } else if (fixedPerViewLg) {
          breakpoints = { 400: { slidesPerView: fixedPerViewLg } };
        } else if (fixedPerView) {
          breakpoints = void 0;
        } else {
          breakpoints = {
            600: { slidesPerView: 2, spaceBetween: 16 },
            900: { slidesPerView: 3, spaceBetween: 16 },
            1200: { slidesPerView: 4, spaceBetween: 16 }
          };
        }
        this._swiper = new Swiper(this, {
          slidesPerView: fixedPerView != null ? fixedPerView : 1.2,
          spaceBetween: 12,
          grabCursor: true,
          preventClicks: false,
          preventClicksPropagation: false,
          centerInsufficientSlides: !this.hasAttribute("data-no-center"),
          breakpointsBase: "container",
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev")
          },
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true
          },
          breakpoints,
          on: {
            afterInit: (swiper) => {
              blockClickWhenDisabled(swiper.navigation.prevEl);
              blockClickWhenDisabled(swiper.navigation.nextEl);
              this.dispatchEvent(
                new CustomEvent("carousel:ready", { bubbles: true })
              );
            }
          }
        });
      }
      disconnectedCallback() {
        var _a;
        (_a = this._swiper) == null ? void 0 : _a.destroy();
        this._swiper = null;
      }
    }
    if (!customElements.get("carousel-el")) {
      customElements.define("carousel-el", CarouselElement);
    }
  })();
})();
